import React from 'react';

import Moment from 'react-moment';


export default class MoleculeCardInfoBar extends React.Component {

  render() {
    const { molecule } = this.props;
    return (
      <div style={{color: '#777', fontSize: 11}}>
        <Moment fromNow>{molecule.modified_at}</Moment>
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/components/MoleculeCard/MoleculeCardInfoBar.jsx